// src/components/Cookies.js
import React, { useEffect } from 'react';
import Header from '../components/Header';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import FooterMain from './FooterMain';

const Cookies = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  
  const currentLang = lang || (navigator.language?.split('-')[0] === 'it' ? 'it' : 'en');
  
  const getLocalizedPath = (path) => {
    return `/${currentLang}${path}`;
  };
  
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div className="App min-h-screen bg-white text-black transition-colors duration-300">
      <Header />
      <div className="flex justify-center p-8">
        <div className="w-full max-w-6xl bg-white text-gray-900 p-8 rounded-lg shadow-lg">
          <h1 className="text-5xl font-bold mb-4 text-center">{t('cookies.title')}</h1>
          <p className="text-justify">{t('cookies.intro')}</p>
          
          <h2 className="text-2xl font-semibold mt-6">{t('cookies.whatAre.title')}</h2>
          <p className="text-justify">{t('cookies.whatAre.description')}</p>
          
          <h2 className="text-2xl font-semibold mt-6">{t('cookies.types.title')}</h2>
          <ul className="ml-8 text-justify space-y-2 list-disc">
            <li><strong>{t('cookies.types.firstParty.title')}:</strong> {t('cookies.types.firstParty.description')}</li>
            <li><strong>{t('cookies.types.thirdParty.title')}:</strong> {t('cookies.types.thirdParty.description')}</li>
            <li><strong>{t('cookies.types.session.title')}:</strong> {t('cookies.types.session.description')}</li>
            <li><strong>{t('cookies.types.persistent.title')}:</strong> {t('cookies.types.persistent.description')}</li>
            <li><strong>{t('cookies.types.technical.title')}:</strong> {t('cookies.types.technical.description')}</li>
            <li><strong>{t('cookies.types.functionality.title')}:</strong> {t('cookies.types.functionality.description')}</li>
            <li><strong>{t('cookies.types.analytical.title')}:</strong> {t('cookies.types.analytical.description')}</li>
            <li><strong>{t('cookies.types.advertising.title')}:</strong> {t('cookies.types.advertising.description')}</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-6">{t('cookies.howWeUse.title')}</h2>
          <ul className="ml-8 text-justify space-y-2 list-disc">
            <li>{t('cookies.howWeUse.item1')}</li>
            <li>{t('cookies.howWeUse.item2')}</li>
            <li>{t('cookies.howWeUse.item3')}</li>
            <li>{t('cookies.howWeUse.item4')}</li>
            <li>{t('cookies.howWeUse.item5')}</li>
            <li>{t('cookies.howWeUse.item6')}</li>
            <li>{t('cookies.howWeUse.item7')}</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-6">{t('cookies.examples.title')}</h2>
          <ul className="ml-8 text-justify space-y-2 list-disc">
            <li><strong>{t('cookies.examples.phpSession.title')}:</strong> {t('cookies.examples.phpSession.description')}</li>
            <li><strong>{t('cookies.examples.gaSession.title')}:</strong> {t('cookies.examples.gaSession.description')}</li>
            <li>{t('cookies.examples.language')}</li>
            <li>{t('cookies.examples.authenticated')}</li>
            <li>{t('cookies.examples.campaigns')}</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-6">{t('cookies.management.title')}</h2>
          <p className="text-justify">{t('cookies.management.description')}</p>
          <ul className="ml-8 text-justify space-y-2 list-disc">
            <li><strong>{t('cookies.management.browsers.ie')}:</strong> {t('cookies.management.browsers.ieSteps')}</li>
            <li><strong>{t('cookies.management.browsers.firefox')}:</strong> {t('cookies.management.browsers.firefoxSteps')}</li>
            <li><strong>{t('cookies.management.browsers.chrome')}:</strong> {t('cookies.management.browsers.chromeSteps')}</li>
            <li><strong>{t('cookies.management.browsers.safari')}:</strong> {t('cookies.management.browsers.safariSteps')}</li>
          </ul>
          
          <p className="text-justify">{t('cookies.management.privateDescription')}</p>
          <ul className="ml-8 text-justify space-y-2 list-disc">
            <li><strong>{t('cookies.management.privateBrowsing.ie')}:</strong> InPrivate.</li>
            <li><strong>{t('cookies.management.privateBrowsing.firefox')}:</strong> Private Browsing.</li>
            <li><strong>{t('cookies.management.privateBrowsing.chrome')}:</strong> Incognito.</li>
            <li><strong>{t('cookies.management.privateBrowsing.safari')}:</strong> Private Browsing.</li>
            <li><strong>{t('cookies.management.privateBrowsing.opera')}:</strong> Private Browsing.</li>
          </ul>
        </div>
      </div>
      <FooterMain />
    </div>
  );
};

export default Cookies;
